<lib-popup-header [title]="'Other'" [canMaximize]="false" [useCustomClose]="true" (popupClosed)="close()"></lib-popup-header>
<div class="w-100 other-vacations-grid">
  <inavista-grid #otherVacationsGrid
    [config]="gridConfig"
    [actionIcons]="actionIcons"
    (rowEditStart)="onRowEditStart()"
    (rowCommit)="onRowCommit($event)"
    (rowRevert)="onRowRevert()"
    (actionIconClick)="onActionIconClick($event)"
    (toolbarActionClick)="onToolbarAction($event)" />
</div>

<div class="d-flex justify-content-end">
  <button class="btn btn-danger footer-buttons m-2" (click)="close();">Close</button>
  @if (canEdit) {
    <button class="btn btn-success footer-buttons m-2" [disabled]="!hasUnsavedChanges()" (click)="close(true);"
      [title]="hasUnsavedChanges() ? 'Add these days to the request' : 'Nothing changed yet'">Add</button>
  }
</div>
